import { InputSelect, InputText } from '@innovyze/stylovyze';
import { useFormikContext } from 'formik';

import { useGlobalization } from '@Translations/useGlobalization';
import { ArcGisSettingsFormValues } from 'features/IntegrationsTab/types/integration.types';

import React from 'react';

export default function ArcGisSettingsValues() {
	const { t } = useGlobalization();
	const { errors } = useFormikContext<ArcGisSettingsFormValues>();
	return (
		<div>
			<InputText
				fieldAttrs={{ name: 'name' }}
				textField={{
					label: t('Enter Name'),
					error: !!errors.name,
					helperText: errors.name,
					disabled: false,
				}}
				dataCy="arcgis-name-input"
			/>
			<InputSelect
				menuItems={[{ key: '--', value: '--', label: t('No Sync') }]}
				fieldAttrs={{ name: 'syncSettings', disabled: true }}
				selectProps={{
					label: t('Synchronization Settings'),
					disabled: true,
					error: !!errors.syncSettings,
				}}
				helperText={errors.syncSettings}
				dataCy="sync-settings-select"
			/>
			<InputText
				fieldAttrs={{ name: 'description' }}
				textField={{
					label: t('Provide a description of the integration'),
					variant: 'outlined',
					multiline: true,
					rows: 6,
					error: !!errors.description,
					helperText: errors.description,
				}}
				dataCy="arcgis-description-input"
			/>
		</div>
	);
}
